<template>
  <div class="input-group">
    <vue-google-autocomplete
      :id="id"
      :name="id"
      type="search"
      classname="form-control map"
      placeholder="Search address"
      v-on:placechanged="getAddress">
    </vue-google-autocomplete>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
  name: "SearchAddress",
  props: {
    formName: String
  },
  components: {
    VueGoogleAutocomplete
  },
  computed: {
    id() {
      return `map_${this.formName}_${new Date().getTime()}`;
    }
  },
  methods: {
    getAddress(addressData, placeResultData) {
      this.$emit("get-address", {
        addressData, 
        placeResultData
      });
    }
  }
}
</script>

<style>

</style>